import styled from 'styled-components'

interface IDividerProps {
  margin?: string
}

export const Divider = styled.div<IDividerProps>`
  width: 100%;
  height: 1px;
  background-color: #1f2124;
  margin: ${(props) => (props.margin ? props.margin : '0px')};
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: auto;
  padding: 0 1% 1% 2%;
  margin-bottom: 40px;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 0px;
  }
`

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 30px;
  padding-bottom: 1%;
  background-color: #eff3fa;
  margin-bottom: 20px;
`

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 20px;
  padding-left: 20px;
`

export const TitleIcon = styled.img`
  width: 48px;
  height: 49px;
`

export const StepsContainer = styled.div`
  display: flex;
  width: 100%;
  height: 3%;
  padding: 2% 0 0 0;
`

//Grids

// grid container
export const GridContainer = styled.div`
  width: 100%;
  padding: 0% 0%;
  padding-top: 20px;
`

// grid with 2 columns, proportion 5:5
export const GridMinimumRecord = styled.div`
  display: grid;
  grid-template-columns: 6fr 6fr;
  width: 100%;
  padding: 0% 0%;
`

interface IGridItemProps {
  flexDirection?: string
  margin?: string
  height?: string
  background?: boolean
}

export const GridItem = styled.div<IGridItemProps>`
  display: flex;
  flex-direction: ${(props) => (props.flexDirection ? props.flexDirection : 'column')};
  width: 100%;
  height: ${(props) => (props.height ? props.height : '60px')};
  padding: 0% 0%;
  margin: ${(props) => (props.margin ? props.margin : '0px')};
  background-color: ${(props) => (props.background ? '#F4F8FF' : '')};
`

export const TitleGrid = styled.p`
  font-size: 16px;
  line-height: 24px;
  color: #1f2124;
  font-family: 'Public Sans', sans-serif;
  font-weight: 600;
  margin: 10px 0px 1px 0px;
`

interface IRowProps {
  width?: string
  justify?: string
  height?: string
  margin?: string
  gap?: string
}

export const Row = styled.div<IRowProps>`
  display: flex;
  flex-direction: row;
  width: ${(props) => (props.width ? props.width : '100%')};
  justify-content: ${(props) => (props.justify ? props.justify : 'flex-start')};
  height: ${(props) => (props.height ? props.height : 'auto')};
  align-items: center;
  margin: ${(props) => (props.margin ? props.margin : '0px')};
  gap: ${(props) => (props.gap ? props.gap : '0px')};
`

// next button

export const NextButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  margin-top: 10px;
  justify-content: space-between;
  align-items: flex-end;
`

export const MinimumRecordContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const ModalCloseButtonContainer = styled.div`
  display: flex;
  width: 98%;
  justify-content: flex-end;
  margin-bottom: 10px;
  z-index: 2;
`

export const DescriptionText = styled.p`
  font-family: 'Public Sans', sans-serif;
  color: #1f2124;
`

export const NavigationText = styled.p`
  font-family: 'Public Sans', sans-serif;
  color: #2d749c;
  font-size: 16px;
  font-weight: 600;
  margin: 2px 6px;

  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
`

export const ModalBottomNavigationContainer = styled.div`
  display: flex;
  flex: 1;
  width: 100%;
  justify-content: space-between;
  align-items: flex-end;
  margin-top: 20px;
  z-index: 2;
`

export const ContainerWithNumbers = styled.div`
  display: flex;
  align-items: center;
  margin-top: 15px;
`

export const SelectContainer = styled.div`
  width: '180px';
`

export const ButtonContainer = styled.div`
  margin-top: 30px;
  margin-bottom: 20px;
`

export const LineContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
`

export const Line = styled.div`
  width: 50%;
  height: 1px;
  background-color: #cbcaca;
  margin-top: 10px;
  margin-bottom: 10px;
`

export const Badge = styled.div`
  position: absolute;
  top: -20px;
  right: -10px;
  background-color: #9ed47d;
  color: #484848;
  font-size: 14px;
  font-weight: 500;
  padding: 6px 12px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  gap: 6px;
  z-index: 10;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`

export const SparkleIcon = styled.img`
  width: 20px;
  height: 20px;
`

export const SparkleIconBlack = styled.img`
  width: 25px;
  height: 25px;
  margin-left: 10px;
  margin-top: 28px;
`

export const CardWithBadgeContainer = styled.div`
  position: relative;
  width: fit-content;
  margin-top: 20px;
`

export const SkillsSelectContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

export const ButtonContainerAI = styled.div`
  display: flex;
  z-index: 1;
  margin-top: 20px;
`

export const ModalAICloseButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  height: 80px;
  z-index: 2;
  background-color: #81acc4;
`

export const ModalTitleContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
`

export const ModalAIContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 40px 60px;
  gap: 30px;
`

export const ModalTitle = styled.div`
  font-weight: 700;
  font-size: 16px;
  line-height: 18px;
  letter-spacing: 0px;
`

export const ModalPlaceHolder = styled.div`
  font-weight: 400;
  font-style: italic;
  font-size: 16px;
  line-height: 18px;
  letter-spacing: 0px;
  color: rgba(121, 122, 124, 0.56);
`

export const ModalSubTitle = styled.div`
  font-weight: 400;
  font-style: italic;
  font-size: 12px;
  line-height: 18px;
  letter-spacing: 0px;
  color: rgba(121, 122, 124, 1);
`

export const ModalQuestionContainer = styled.div<{ column?: boolean }>`
  display: flex;
  flex-direction: ${(props) => (props.column ? 'column' : 'row')};
  gap: 10px;
  margin-bottom: 20px;
`

export const CharCounter = styled.div<{ isExceeded: boolean }>`
  text-align: right;
  font-size: 12px;
  color: ${(props) => (props.isExceeded ? '#e53935' : '#666')};
`

export const ErrorText = styled.span`
  color: red;
  text-align: left !important;
  margin: 0;
`

export const ModalInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`

export const Form = styled.form``

export const ModalAIButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 20px;
`

export const CircleNumber = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 2px solid #2d749c;
  color: #2d749c;
  font-weight: bold;
  font-size: 15px;
`

export const TextContainer = styled.div`
  position: relative;
  background-color: #f4f8ff;
  margin-top: 30px;
  padding: 0px 0 30px 30px;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
`

export const BottomTableContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #f4f8ff;
  padding: 30px 10px 30px 20px;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
`

export const BottomButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  gap: 20px;
  margin-top: 20px;
`

export const TableHeaderAbsolute = styled.div`
  position: absolute;
  top: 150px;
  right: 185px;
  font-weight: 700;

  @media (max-width: 1479px) {
    top: 175px;
  }
`

export const SelectAndButtonContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: -110px;

  @media (max-width: 1725px) {
    width: 90%;
  }
  @media (max-width: 1600px) {
    width: 80%;
  }
  @media (max-width: 1480px) {
    width: 70%;
  }
  @media (max-width: 1370px) {
    width: 65%;
  }
  @media (max-width: 1225px) {
    width: 63%;
  }
  @media (max-width: 1165px) {
    gap: 20px;
  }
  @media (max-width: 1155px) {
    width: 60%;
  }
  @media (max-width: 1086px) {
    width: 57%;
  }
  @media (max-width: 1024px) {
    width: 55%;
  }
`
